import nodeClient from "./node-client";

export const addDiscountProgram = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/discount/program/add`,
    payload
  );
  return response?.data;
};

export const fetchDiscountProgramDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/discount/program/findOne?${query}`
  );
  return response?.data;
};

export const addLoyaltyProgram = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/loyalty/program/add`,
    payload
  );
  return response?.data;
};

export const fetchLoyaltyProgramDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/loyalty/program/findOne?${query}`
  );
  return response?.data;
};
